import React, { useState } from "react";
import { Checkbox, Form, Select, Upload, Input } from "antd";

function ChooseColumns({ form, data, handleSubmit }) {
  return (
    <div className="flex flex-col justify-center items-center p-20">
      <p className="bold text-[20px] mb-30 mt-30">Escolha as colunas que deseja exportar</p>
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item name="columns" rules={[{ required: true, message: "Este é um campo obrigatório" }]}>
          <Checkbox.Group>
            {Object.keys(data[0]).map((item) => (
              <Checkbox value={item}>{item}</Checkbox>
            ))}
          </Checkbox.Group>
        </Form.Item>
      </Form>
    </div>
  );
}

export default ChooseColumns;
